<template>
  <div class="banner">
    <a :href="covidURL" target="_blank">
      Change your bottom line. Click for Covid relief fees.
    </a>
  </div>
</template>

<script>
export default {
  computed: {
    covidURL() {
      switch (process.env.VUE_APP_ENVIRONMENT) {
        case "development":
          return "http://localhost:3200/covid-relief";
        case "staging":
          return "https://staging.incredevent.com/covid-relief";
        default:
          return "https://incredevent.com/covid-relief";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.banner {
  position: sticky;
  top: 0;
  justify-content: center;
  // width: 100%;
  height: 35px;
  display: flex;
  font-weight: 600;
  align-items: center;
  z-index: 50;
  background: var(--primary-orange);

  &.stepper {
    top: 80px;
  }
  a {
    color: white;
  }
}
@media screen and (max-width: 600px) {
  .banner {
    height: 25px;
    font-size: 14px;
    padding: 0 8px;
  }
  // a {
  // }
}
@media screen and (max-width: 400px) {
  .banner {
    font-size: 3.5vw;
  }
  // a {
  // }
}
</style>